import { createActions } from 'reduxsauce';

const { Types, Creators } = createActions({
  // View actions
  activateCarnetUniversity: [
    'requestId',
    'procedureId',
    'deliveryMode',
    'career'
  ],
  // Reducer
  activateCarnetUniversityClear: null,
  activateCarnetUniversityRequest: null,
  activateCarnetUniversitySuccess: null,
  activateCarnetUniversityFailure: ['error']
});

export { Creators, Types };
